import FullScreenLoader from "../../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { TagsInput } from "react-tag-input-component";
import {
  AddRoomDetails,
  Property,
  PropertyMealplan,
  PropertyRateCode,
  ReserBookingDetail,
  ReserBusinessSource,
  ReserDeletePreBookingRoom,
  ReserGuaranteeCodes,
  ReserSaveGroupBookingconfirm,
  ReservationMarketSegmentApi,
  ReservationPMSDetails,
  roomlistdetail,
} from "../../../Services/Service";
import ReservationSidebar from "../../Commun/ReservationSidebar";
import ReservationHeader from "../../Commun/ReservationHeader";
import { useProperty } from "../../../PropertyContext";
import "../ReserNewBooking.css";

const FinalGroupBooking = () => {
  const navigate = useNavigate();
  const { selectedProperty } = useProperty();
  const [loading, setLoading] = useState(false);
  const [masterDetails, setMasterDetails] = useState({});
  const [roomDetails, setRoomDetails] = useState([]);
  const [tax, setTax] = useState(0);
  const [, setTotalAmount] = useState(0);
  const [, setTotalAfterTax] = useState(0);
  const [, setTaxAmount] = useState(0);
  const [, setRooms] = useState([]);
  const [marketSegments, setMarketSegments] = useState([]);
  const [businessSources, setBusinessSources] = useState([]);
  const [tempAmount, setTempAmount] = useState({});
  const [Pms, setPMS] = useState();
  const [guaranteeCodes, setGuaranteeCodes] = useState([]);
  const [, setRatecode] = useState([]);
  const [, setMealplan] = useState([]);

  // rowKey ab sirf roomIdx (string) hai -> "0", "1", "2" ... (ek row per RoomDetails object)
  const [editingRowKey, setEditingRowKey] = useState(null);

  const [savedAmounts, setSavedAmounts] = useState({});

  const [rowTax, setRowTax] = useState({});
  const [rowTaxAmount, setRowTaxAmount] = useState({});
  const [rowTotal, setRowTotal] = useState({});
  const [, setSavedRowTaxAmount] = useState({});

  const [isCopied, setIsCopied] = useState(false);
  const [, setCopiedAmount] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [selectedOperaSource, setSelectedOperaSource] = useState(null);

  // track property change -> sirf is page ke liye
  const prevPropertyIdRef = useRef(undefined);

  useEffect(() => {
    const currentId = selectedProperty?.PropertyID;

    if (currentId === undefined) return; // property abhi load hi nahi hui

    // pehli baar mount hone par sirf record karo, refresh mat karo
    if (prevPropertyIdRef.current === undefined) {
      prevPropertyIdRef.current = currentId;
      return;
    }

    // agar property change hui
    if (prevPropertyIdRef.current !== currentId) {
      prevPropertyIdRef.current = currentId;

      localStorage.removeItem("PreBookingToken");

      // hard refresh isi page par
      window.location.href = "/Reservation/NewBooking";
    }
  }, [selectedProperty]);

  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        const result = await ReserBookingDetail();

        if (result?.MasterDetails?.length) {
          const master = result.MasterDetails[0];
          setMasterDetails(master);

          // Try to parse CompDetails (it may be a JSON string like "[{...}]")
          try {
            const compRaw = master.CompDetails;
            if (compRaw) {
              let compParsed = compRaw;

              // If it's a string, try to JSON.parse
              if (typeof compRaw === "string") {
                compParsed = JSON.parse(compRaw);
              }

              const compObj = Array.isArray(compParsed)
                ? compParsed[0]
                : compParsed;

              if (compObj && typeof compObj === "object") {
                setFormData((prev) => ({
                  ...prev,
                  RegistrationNumber: compObj.Gst || "",
                  RegistrationCompanyName: compObj.TA_Name || "",
                  RegistrationCompanyAddress: compObj.Address || "",

                  MarketSegment: compObj.MarketSegment || "",
                  BusinessSource: compObj.BusinessSource || "",
                  GuaranteeCodes: compObj.guaranteeCodes || "",
                }));
              }
            }
          } catch (parseErr) {
            console.warn("Failed to parse CompDetails:", parseErr);
          }
        }

        if (result?.RoomDetails?.length) {
          setRoomDetails(result.RoomDetails);

          const amount = result.RoomDetails.reduce((acc, room) => {
            const roomRate = room.RoomRate || room.PerRoomRate || 0;
            const totalRoomCount = room.TotalRoom || 1;

            const extraBedTotal =
              room.ExtraBedAmount !== undefined
                ? room.ExtraBedAmount
                : (room.ExtraBed || 0) * (room.ExtraBedCharges || 0);

            return acc + totalRoomCount * roomRate + extraBedTotal;
          }, 0);

          setTotalAmount(amount);

          let taxPercent = 0;
          if (
            result?.TaxDetails &&
            result.TaxDetails.length &&
            result.TaxDetails[0].Tax != null
          ) {
            taxPercent = Number(result.TaxDetails[0].Tax) || 0;
          } else {
            taxPercent = amount < 7500 ? 5 : 18;
          }
          setTax(taxPercent);

          const calculatedTaxAmount = (amount * taxPercent) / 100;
          setTaxAmount(calculatedTaxAmount);

          const afterTax = amount + calculatedTaxAmount;
          setTotalAfterTax(afterTax);
        }
      } catch (err) {
        console.error("Failed to fetch booking data", err);
      }
    };

    fetchBookingData();
  }, []);

  // ✅ FIX: ab har RoomDetails object ke liye SIRF EK rowKey banti hai (roomIdx),
  // pehle yahan room.TotalRoom ke hisaab se andar ek aur loop chalta tha jo
  // duplicate rows create kar raha tha.
  useEffect(() => {
    if (!roomDetails || roomDetails.length === 0) return;

    const newRowTax = {};
    const newRowTaxAmount = {};
    const newRowTotal = {};

    roomDetails.forEach((room, roomIdx) => {
      const rowKey = `${roomIdx}`;

      // ✅ FIX: yahan se TotalRoom multiplication hata di - Amount ab
      // raw/per-room value hai, jo aa rahi hai wahi hai, multiply nahi hoti.
      const defaultAmount =
        room.Amount ?? room.RoomRate + (room.ExtraBedAmount || 0);

      // Tax/Total nikalne ke liye hi Rooms count se multiply karo (display Amount se nahi)
      const taxableAmount = defaultAmount * (room.TotalRoom || 1);

      const taxPercent = taxableAmount < 7500 ? 5 : 18;

      const taxAmt = (taxableAmount * taxPercent) / 100;
      const total = taxableAmount + taxAmt;

      newRowTax[rowKey] = taxPercent;
      newRowTaxAmount[rowKey] = taxAmt;
      newRowTotal[rowKey] = total;
    });

    setRowTax(newRowTax);
    setRowTaxAmount(newRowTaxAmount);
    setRowTotal(newRowTotal);
  }, [roomDetails]);

  const calculateNights = (checkInIso, checkOutIso) => {
    if (!checkInIso || !checkOutIso) return 0;

    const inDateStr = checkInIso.split("T")[0];
    const outDateStr = checkOutIso.split("T")[0];

    const inDate = new Date(inDateStr + "T00:00:00");
    const outDate = new Date(outDateStr + "T00:00:00");

    const diffMs = outDate.getTime() - inDate.getTime();
    if (isNaN(diffMs) || diffMs <= 0) return 0;

    const days = Math.round(diffMs / (24 * 60 * 60 * 1000));
    return days;
  };

  const [formData, setFormData] = useState({
    Title: "Mr.",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    EmailAddress: [],
    Address: "",
    MobileNumber: "",
    Country: "",
    State: "",
    City: "",
    CompanyName: "",
    RegistrationNumber: "",
    RegistrationCompanyName: "",
    RegistrationCompanyAddress: "",

    BillingInstruction: "",
    MarketSegment: "",
    BusinessSource: "",
    GuaranteeCodes: "",
    BookingComment: "",
    PaymentComment: "",
    BookingProcessingFee: "",
  });

  const handleSelectOperaSource = (item) => {
    const profileId = item?.profileIdList?.find(
      (x) => x.type === "Profile",
    )?.id;

    const fullName = item?.profile?.formerName?.fullName || "";

    setSelectedOperaSource({
      ProfileID: profileId,
      ProfileName: fullName,
    });

    document.querySelector("#SearchAgentModal .btn-close")?.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const {
      Title,
      FirstName,
      LastName,
      MobileNumber,
      BillingInstruction,
      MarketSegment,
      BusinessSource,
      GuaranteeCodes,
      BookingComment,
      PaymentComment,
    } = formData;

    if (!Title || !FirstName || !LastName || !MobileNumber) {
      swal("Please fill all guest details ", {
        icon: "warning",
        buttons: { confirm: { text: "OK", className: "btn btn-warning" } },
      });
      setLoading(false);
      return;
    }

    if (!BillingInstruction) {
      swal("Please select Billing Instruction", { icon: "warning" });
      return setLoading(false);
    }

    if (!MarketSegment) {
      swal("Please select Market Segment", { icon: "warning" });
      return setLoading(false);
    }

    if (!BusinessSource) {
      swal("Please select Business Source", { icon: "warning" });
      return setLoading(false);
    }

    if (!GuaranteeCodes) {
      swal("Please select Guarantee Code", { icon: "warning" });
      return setLoading(false);
    }

    if (!BookingComment) {
      swal("Please Enter Booking Comment", { icon: "warning" });
      return setLoading(false);
    }

    if (!PaymentComment) {
      swal("Please Enter Payment Comment", { icon: "warning" });
      return setLoading(false);
    }

    if (
      (masterDetails?.RateCode === "Travel Agent" ||
        masterDetails?.RateCode === "Corporate") &&
      (!formData.RegistrationNumber ||
        !formData.RegistrationCompanyName ||
        !formData.RegistrationCompanyAddress)
    ) {
      swal(
        "Please enter Registration Number, Company Name and Company Address.",
        {
          icon: "warning",
          buttons: { confirm: { text: "OK", className: "btn btn-warning" } },
        },
      );
      setLoading(false);
      return;
    }

    // ✅ FIX: ab per-room (not per TotalRoom-instance) check hoti hai
    const hasZeroOrInvalidAmount = roomDetails
      .map((room, roomIdx) => {
        const rowKey = `${roomIdx}`;

        const defaultAmount =
          room.Amount ?? room.RoomRate + (room.ExtraBedAmount || 0);

        const finalAmount = savedAmounts[rowKey] ?? defaultAmount ?? 0;

        return Number(finalAmount);
      })
      .some((amount) => amount <= 0);

    if (hasZeroOrInvalidAmount) {
      swal("Room amount must be greater than 0.", {
        icon: "warning",
        buttons: { confirm: { text: "OK", className: "btn btn-warning" } },
      });
      setLoading(false);
      return;
    }

    // 🚨 FINAL SAFETY CHECK BEFORE SUBMIT (per-room, not per instance)
    const hasInvalidRoomRate = roomDetails.some((room, roomIdx) => {
      const rowKey = `${roomIdx}`;

      const finalAmount =
        savedAmounts[rowKey] ?? room.RoomRate ?? room.Amount ?? 0;

      return Number(finalAmount) <= 0;
    });

    if (hasInvalidRoomRate) {
      swal(
        "One or more rooms have Room Rate 0. Please update before submitting.",
        {
          icon: "warning",
          buttons: { confirm: { text: "OK", className: "btn btn-warning" } },
        },
      );

      setLoading(false);
      return;
    }

    // FINAL API CHECK FOR ROOM RATE
    try {
      const latestData = await ReserBookingDetail();

      if (latestData?.RoomDetails?.length) {
        const hasZeroRoomRate = latestData.RoomDetails.some(
          (room) => Number(room.RoomRate) <= 0,
        );

        if (hasZeroRoomRate) {
          swal("Something Wrong", {
            icon: "error",
            buttons: { confirm: { text: "OK", className: "btn btn-danger" } },
          });

          setLoading(false);
          return;
        }
      } else {
        swal("Something Wrong", { icon: "error" });

        setLoading(false);
        return;
      }
    } catch (err) {
      console.error("Error checking RoomRate", err);

      swal("Something Wrong", { icon: "error" });

      setLoading(false);
      return;
    }

    const selectedBusinessSource = businessSources.find(
      (item) => item.Code === formData.BusinessSource,
    );

    const payload = {
      PreBookingToken: masterDetails?.PreBookingToken,
      PropertyID: selectedProperty?.PropertyID,
      TotalRoomRate: baseAmount,
      TotalExtraBedCharges: 0,
      TotalPayment: baseAmount,
      Tax: tax,
      TotalAfterTax: finalTotalAfterTax,
      Discount: 0,

      SourceProfileID:
        selectedOperaSource?.ProfileID || selectedBusinessSource?.ProfileID,
      SourceName:
        selectedOperaSource?.ProfileName || selectedBusinessSource?.ProfileName,
      BookingProcessingFee: formData.BookingProcessingFee,

      ...formData,
    };

    // console.log("Idex Block Payload", JSON.stringify(payload, null, 2));

    try {
      await ReserSaveGroupBookingconfirm(payload);

      swal("Your booking details submitted to Hotel", {
        icon: "success",
        buttons: { confirm: { text: "OK", className: "btn btn-success" } },
      }).then(() => {
        navigate("/Reservation/Bookinglist", { state: { showSuccess: true } });
      });
    } catch (error) {
      swal("Booking Failed.", {
        icon: "error",
        buttons: { confirm: { text: "OK", className: "btn btn-danger" } },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteRoom = (roomId) => {
    if (!roomId) {
      alert("Missing Room ID.");
      return;
    }

    swal({
      title: "Are you sure?",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
          className: "btn btn-danger",
          closeModal: true,
        },
        confirm: {
          text: "Yes, delete it",
          className: "btn btn-success",
        },
      },
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;

      setLoading(true);

      try {
        const result = await ReserDeletePreBookingRoom(
          roomId,
          masterDetails?.PreBookingToken,
          selectedProperty.PropertyID,
        );

        if (result?.PreBookingToken) {
          const updatedRooms = roomDetails.filter((r) => r.ID !== roomId);
          setRoomDetails(updatedRooms);

          const amount = updatedRooms.reduce(
            (acc, r) =>
              acc +
              (r.Amount !== undefined
                ? r.Amount
                : r.TotalRoom * r.RoomRate + (r.ExtraBedAmount || 0)),
            0,
          );
          setTotalAmount(amount);

          const taxPercent = tax;
          const taxAmt = (amount * taxPercent) / 100;
          setTaxAmount(taxAmt);
          setTotalAfterTax(amount + taxAmt);
        } else {
          alert("Failed to delete room.");
        }
      } catch (error) {
        console.error("Error deleting room:", error);
        alert("Something went wrong while deleting the room.");
      } finally {
        setLoading(false);
      }
    });
  };

  // add room api
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const result = await roomlistdetail();
        if (result && Array.isArray(result)) {
          setRooms(result);
        }
      } catch (err) {
        console.error("Error fetching rooms:", err);
      }
    };
    fetchRooms();
  }, []);

  useEffect(() => {
    if (!roomDetails || !roomDetails.length) return;

    const newTotal = roomDetails.reduce((acc, r) => {
      const roomRate = Number(r.RoomRate || r.Amount || 0);
      const extraBed = Number(r.ExtraBedAmount || 0);
      const totalRoomCount = Number(r.TotalRoom || 1);
      return acc + totalRoomCount * roomRate + extraBed;
    }, 0);

    setTotalAmount(newTotal);

    const taxPercent = newTotal < 7500 ? 5 : 18;
    setTax(taxPercent);

    const calculatedTaxAmount = (newTotal * taxPercent) / 100;
    setTaxAmount(calculatedTaxAmount);

    setTotalAfterTax(newTotal + calculatedTaxAmount);
  }, [roomDetails]);

  const handleEditClick = (rowKey, initialAmount, roomCount = 1) => {
    setEditingRowKey(rowKey);

    setTempAmount((prev) => ({
      ...prev,
      [rowKey]: initialAmount,
    }));

    setRowTax((prev) => ({
      ...prev,
      [rowKey]: prev[rowKey] ?? 5,
    }));

    calculateRowAmounts(rowKey, initialAmount, 5, roomCount);
  };

  const handleAmountInputChange = (rowKey, value) => {
    const numericValue = value === "" ? "" : parseFloat(value);
    setTempAmount((prev) => ({ ...prev, [rowKey]: numericValue }));
  };

  const handleCancelClick = () => {
    setEditingRowKey(null);
  };

  // ✅ FIX: ab sirf ek room object ke liye save hota hai (index param hata diya),
  // aur end mein wo leftover duplicate/dead "formData" call hata diya jo out-of-scope
  // variable use kar raha tha (bug tha original code mein).
  const handleSaveClick = async (rowKey, room) => {
    const typedVal = tempAmount[rowKey];
    const numericValue =
      typedVal === "" || typedVal === undefined ? 0 : Number(typedVal);

    if (numericValue <= 0) {
      swal("Amount must be greater than 0", {
        icon: "warning",
        buttons: { confirm: { text: "OK", className: "btn btn-warning" } },
      });
      return;
    }

    setSavedAmounts((prev) => ({
      ...prev,
      [rowKey]: numericValue,
    }));

    const selectedTaxAmount = Number(rowTaxAmount[rowKey] ?? 0);

    setSavedRowTaxAmount((prev) => ({
      ...prev,
      [rowKey]: selectedTaxAmount,
    }));

    try {
      const preBookingToken = localStorage.getItem("PreBookingToken") || "";

      // 🔥 COPY MODE + FIRST ROW → SAVE ALL ROOMS
      if (isCopied && rowKey === "0") {
        for (const [roomIdx, r] of roomDetails.entries()) {
          const key = `${roomIdx}`;

          const amt = savedAmounts[key] ?? numericValue;

          const taxPercent = Number(rowTax[key] ?? rowTax[rowKey] ?? 5);
          const taxAmt = (amt * taxPercent) / 100;

          const fd = new FormData();
          fd.append("PropertyID", selectedProperty?.PropertyID);
          fd.append("ID", r.ID || "N/A");
          fd.append("PreBookingToken", preBookingToken);
          fd.append("RoomID", r.RoomID);
          fd.append("RatePlanID", r.RatePlanID);
          fd.append("TotalRoom", r.TotalRoom);
          fd.append("RoomRate", amt);
          fd.append("ExtraBed", r.ExtraBed);
          fd.append("ExtraBedAmount", r.ExtraBedAmount);
          fd.append("Adults", r.Adults);
          fd.append("Child", r.Child);
          fd.append("MealPlanID", r.MealPlanID);
          fd.append("Tax", taxPercent);
          fd.append("TaxRate", taxAmt);
          fd.append("NetAmount", amt + taxAmt);

          await AddRoomDetails(fd);
        }
      } else {
        // ✅ NORMAL SINGLE ROW SAVE
        const fd = new FormData();
        fd.append("PropertyID", selectedProperty?.PropertyID);
        fd.append("ID", room.ID || "N/A");
        fd.append("PreBookingToken", preBookingToken);
        fd.append("RoomID", room.RoomID);
        fd.append("RatePlanID", room.RatePlanID || "");
        fd.append("TotalRoom", room.TotalRoom || 1);
        fd.append("RoomRate", numericValue);
        fd.append("ExtraBed", room.ExtraBed || 0);
        fd.append("ExtraBedAmount", room.ExtraBedAmount || 0);
        fd.append("Adults", room.Adults || 0);
        fd.append("Child", room.Child || 0);
        fd.append("MealPlanID", room.MealPlanID || "Null");

        fd.append("Tax", Number(rowTax[rowKey] ?? 0));
        fd.append("TaxRate", selectedTaxAmount);
        fd.append("NetAmount", numericValue + selectedTaxAmount);

        const result = await AddRoomDetails(fd);

        if (result?.RoomDetails) {
          setRoomDetails(result.RoomDetails);
        }
      }

      swal("Amount Updated Successfully", {
        icon: "success",
        buttons: { confirm: { text: "OK", className: "btn btn-success" } },
      });
    } catch (error) {
      console.error("Error saving room data:", error);
    }

    setEditingRowKey(null);
  };

  useEffect(() => {
    const fetchSegments = async () => {
      try {
        setLoading(true);
        const data = await ReservationMarketSegmentApi(
          selectedProperty?.PropertyID,
        );
        if (data && Array.isArray(data)) {
          setMarketSegments(data);
        }
      } catch (err) {
        console.error("Error fetching market segments", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSegments();
  }, [selectedProperty]);

  // get Business Source
  useEffect(() => {
    const fetchBusinessSources = async () => {
      try {
        const data = await ReserBusinessSource(selectedProperty?.PropertyID);
        if (data && Array.isArray(data)) {
          setBusinessSources(data);
        }
      } catch (error) {
        console.error("Error fetching business sources", error);
      }
    };
    fetchBusinessSources();
  }, [selectedProperty]);

  useEffect(() => {
    const FetchPMS = async () => {
      if (!selectedProperty?.PropertyID) return;

      try {
        const result = await Property();
        const matched = result.find(
          (p) => p.PropertyID === selectedProperty.PropertyID,
        );
        setPMS(matched || null);
      } catch (error) {
        console.log("error fetch PMS", error);
      }
    };
    FetchPMS();
  }, [selectedProperty]);

  useEffect(() => {
    const fetchGuaranteeCodes = async () => {
      setLoading(true);
      try {
        const data = await ReserGuaranteeCodes(selectedProperty?.PropertyID);
        if (Array.isArray(data)) setGuaranteeCodes(data);
      } catch (error) {
        console.log("Error fetching gurantee Codes:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGuaranteeCodes();
  }, [selectedProperty]);

  useEffect(() => {
    const fetchRatecode = async () => {
      setLoading(true);
      try {
        const result = await PropertyRateCode();
        if (Array.isArray(result)) setRatecode(result);
      } catch (error) {
        console.log("error get rate code", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRatecode();
  }, []);

  useEffect(() => {
    const FetchMealplan = async () => {
      setLoading(true);
      try {
        const result = await PropertyMealplan();
        if (Array.isArray(result)) setMealplan(result);
      } catch (error) {
        console.log("error get meal plan", error);
      } finally {
        setLoading(false);
      }
    };
    FetchMealplan();
  }, []);

  // ✅ FIX: 4th param "roomCount" add kiya (= room.TotalRoom / Rooms column).
  // Amount input mein jo bhi value dali jaati hai, wo PER ROOM rate maani jaati hai,
  // isliye Tax aur Total ab (amount * roomCount) ke base par calculate hote hain.
  const calculateRowAmounts = (rowKey, amount, taxPercent, roomCount = 1) => {
    const taxableAmount = Number(amount) * Number(roomCount || 1);
    const taxAmt = (taxableAmount * Number(taxPercent || 0)) / 100;
    const total = taxableAmount + taxAmt;

    setRowTaxAmount((prev) => ({
      ...prev,
      [rowKey]: taxAmt,
    }));

    setRowTotal((prev) => ({
      ...prev,
      [rowKey]: total,
    }));
  };

  const nights =
    calculateNights(masterDetails?.CheckInDate, masterDetails?.CheckOutDate) ||
    0;

  // ✅ BASE AMOUNT = har room ka (raw amount x Rooms) sum, phir Nights se multiply.
  // Amount box khud raw/per-room dikhta hai (multiply nahi hota), Rooms factor
  // sirf yahan total nikalne ke liye laga hai — taaki ye row-level Total column
  // ke sath match kare.
  const baseAmount =
    roomDetails
      .map((room, roomIdx) => {
        const rowKey = `${roomIdx}`;

        const perRoomAmount =
          room.Amount ?? room.RoomRate + (room.ExtraBedAmount || 0);

        const finalAmount = Number(savedAmounts[rowKey] ?? perRoomAmount ?? 0);

        return finalAmount * (room.TotalRoom || 1);
      })
      .reduce((sum, val) => sum + Number(val), 0) * nights;

  const finalTaxAmount =
    Object.values(rowTaxAmount).reduce(
      (sum, val) => sum + Number(val || 0),
      0,
    ) * nights;

  const finalTotalAfterTax = baseAmount + finalTaxAmount;

  const handleCopyToAll = async (amount) => {
    const newSaved = {};
    const newTax = {};
    const preBookingToken = localStorage.getItem("PreBookingToken") || "";

    try {
      const firstRowKey = "0";
      const globalTax = Number(rowTax[firstRowKey] ?? 5);

      for (const [roomIdx, room] of roomDetails.entries()) {
        const key = `${roomIdx}`;

        newSaved[key] = amount;
        newTax[key] = globalTax;

        const taxAmt = (amount * globalTax) / 100;

        // ✅ UI UPDATE (Rooms ke hisab se multiply)
        calculateRowAmounts(key, amount, globalTax, room.TotalRoom);

        // ✅ API CALL
        const fd = new FormData();
        fd.append("PropertyID", selectedProperty?.PropertyID);
        fd.append("ID", room.ID || "N/A");
        fd.append("PreBookingToken", preBookingToken);
        fd.append("RoomID", room.RoomID);
        fd.append("RatePlanID", room.RatePlanID || "");
        fd.append("TotalRoom", room.TotalRoom || 1);
        fd.append("RoomRate", amount);
        fd.append("ExtraBed", room.ExtraBed || 0);
        fd.append("ExtraBedAmount", room.ExtraBedAmount || 0);
        fd.append("Adults", room.Adults || 0);
        fd.append("Child", room.Child || 0);
        fd.append("MealPlanID", room.MealPlanID || "Null");

        fd.append("Tax", globalTax);
        fd.append("TaxRate", taxAmt);
        fd.append("NetAmount", amount + taxAmt);

        await AddRoomDetails(fd);
      }

      // ✅ FINAL UI UPDATE
      setSavedAmounts(newSaved);
      setRowTax(newTax);
      setCopiedAmount(amount);
      setIsCopied(true);

      swal("All rows updated successfully", {
        icon: "success",
        buttons: { confirm: { text: "OK", className: "btn btn-success" } },
      });
    } catch (error) {
      console.error("Bulk save error:", error);

      swal("Error while saving copied data", { icon: "error" });
    }
  };

  const handleRemoveCopy = async () => {
    const newSaved = {};
    const newTax = {};
    const preBookingToken = localStorage.getItem("PreBookingToken") || "";

    try {
      for (const [roomIdx, room] of roomDetails.entries()) {
        const key = `${roomIdx}`;

        // 🔹 ORIGINAL AMOUNT
        const originalAmount = room.Amount ?? (room.RoomRate || 0);

        newSaved[key] = originalAmount;

        // 🔥 TAX RESET
        const taxPercent = originalAmount < 7500 ? 5 : 18;
        newTax[key] = taxPercent;

        const taxAmt = (originalAmount * taxPercent) / 100;

        // 🔹 UI UPDATE (Rooms ke hisab se multiply)
        calculateRowAmounts(key, originalAmount, taxPercent, room.TotalRoom);

        // 🔹 API CALL
        const fd = new FormData();
        fd.append("PropertyID", selectedProperty?.PropertyID);
        fd.append("ID", room.ID || "N/A");
        fd.append("PreBookingToken", preBookingToken);
        fd.append("RoomID", room.RoomID);
        fd.append("RatePlanID", room.RatePlanID || "");
        fd.append("TotalRoom", room.TotalRoom || 1);
        fd.append("RoomRate", originalAmount);
        fd.append("ExtraBed", room.ExtraBed || 0);
        fd.append("ExtraBedAmount", room.ExtraBedAmount || 0);
        fd.append("Adults", room.Adults || 0);
        fd.append("Child", room.Child || 0);
        fd.append("MealPlanID", room.MealPlanID || "Null");

        fd.append("Tax", taxPercent);
        fd.append("TaxRate", taxAmt);
        fd.append("NetAmount", originalAmount + taxAmt);

        await AddRoomDetails(fd);
      }

      // FINAL RESET
      setSavedAmounts(newSaved);
      setRowTax(newTax);
      setCopiedAmount(null);
      setIsCopied(false);

      swal("Copy removed successfully", { icon: "success" });
    } catch (error) {
      console.error("Error removing copy:", error);

      swal("Error while removing copied data", { icon: "error" });
    }
  };

  const handlePMSDetailSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;

    try {
      setLoading(true);

      const res = await ReservationPMSDetails(
        searchTerm,
        "Source",
        selectedProperty?.PropertyID,
      );

      const profiles = res?.Result?.profileSummaries?.profileInfo || [];
      setResults(profiles);
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {" "}
        {`
        th {
          background-color:#a2a7b7 !important;
          color: #fff !important;
        }
          .table td {
    border-bottom: 0px;
      }
      `}
      </style>

      {loading && (
        <FullScreenLoader />
      )}

      <div className="wrapper">
        <ReservationSidebar />
        <div className="main-panel">
          <ReservationHeader />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card mb-0 ">
                    <div className="card-header">
                      <h4 className="card-title mb-0">
                        Reservation Room Details
                      </h4>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">Arrival:</label>
                              <input
                                type="date"
                                className="form-control"
                                value={
                                  masterDetails?.CheckInDate?.split("T")[0] ||
                                  ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Departure:
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                value={
                                  masterDetails?.CheckOutDate?.split("T")[0] ||
                                  ""
                                }
                                readOnly
                              />
                            </div>
                          </div>

                          <div className="col-md-1 mb-3">
                            <div className="input-block ">
                              <label className="col-form-label">Nights</label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  calculateNights(
                                    masterDetails?.CheckInDate,
                                    masterDetails?.CheckOutDate,
                                  ) || 0
                                }
                                readOnly
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Rate Code:
                              </label>
                              <select
                                className="form-control form-select"
                                value={masterDetails?.RateCode || ""}
                                disabled
                              >
                                <option value="">
                                  {masterDetails?.RateCode || "Select Type"}
                                </option>
                              </select>
                            </div>
                          </div>

                          {/*hotel rooom table */}

                          <div className="col-md-12">
                            <div className="table-responsive room-rate-table-wrap">
                              <div className="text-end"></div>
                              <table className="display table table-bordered room-rate-table final-group-room-table">
                                <thead>
                                  <tr>
                                    <th className="room-col-type">
                                      {" "}
                                      Room Type{" "}
                                    </th>

                                    {Pms?.PMS === "Opera" && (
                                      <th className="room-col-plan">
                                        Rate Plan
                                      </th>
                                    )}
                                    <th className="room-col-meal">
                                      {" "}
                                      Meal Plan{" "}
                                    </th>
                                    <th className="room-col-count">Adults</th>
                                    <th className="room-col-count">Children</th>
                                    <th className="room-col-count room-col-extra-bed">
                                      Extra Beds
                                    </th>
                                    <th className="room-col-amount">
                                      {" "}
                                      Amount{" "}
                                    </th>
                                    <th className="room-col-count"> Rooms </th>
                                    <th className="room-col-tax-rate">Tax %</th>
                                    <th className="room-col-money">Tax</th>
                                    <th className="room-col-money">Total</th>
                                    <th className="room-col-action">
                                      {" "}
                                      Action{" "}
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {/* ✅ FIX: pehle flatMap + Array.from(TotalRoom) chal raha tha jo
                                      TotalRoom=2 hone par ek hi room-object se 2 rows bana raha tha.
                                      Ab seedha .map() -> 1 RoomDetails object = 1 row. */}
                                  {roomDetails.map((room, roomIdx) => {
                                    const rowKey = `${roomIdx}`;

                                    const isFirstRow = roomIdx === 0;

                                    const defaultAmount =
                                      room.Amount ??
                                      room.PerRoomRate +
                                        (room.ExtraBedAmount || 0);
                                    // console.log("defaultAmount", defaultAmount);

                                    const displayedValue =
                                      editingRowKey === rowKey
                                        ? (tempAmount[rowKey] ?? defaultAmount)
                                        : (savedAmounts[rowKey] ??
                                          defaultAmount);

                                    return (
                                      <tr key={rowKey}>
                                        <td
                                          className="room-col-type"
                                          title={room.RoomName}
                                        >
                                          {room.RoomName}
                                        </td>
                                        {Pms?.PMS === "Opera" && (
                                          <td
                                            className="room-col-plan"
                                            title={room.RatePlan}
                                          >
                                            {room.RatePlan}
                                          </td>
                                        )}
                                        <td className="room-col-meal">
                                          {room.MealPlan}
                                        </td>

                                        <td className="text-center room-col-count">
                                          {room.Adults}
                                        </td>
                                        <td className="text-center room-col-count">
                                          {room.Child}
                                        </td>
                                        <td className="text-center room-col-count room-col-extra-bed">
                                          {room.ExtraBed}
                                        </td>

                                        <td className="text-center room-col-amount">
                                          <div className="room-amount-control">
                                            <input
                                              type="number"
                                              min="1"
                                              step="1"
                                              readOnly={
                                                editingRowKey !== rowKey
                                              }
                                              value={displayedValue}
                                              onChange={(e) => {
                                                const val =
                                                  Number(e.target.value) || 0;

                                                handleAmountInputChange(
                                                  rowKey,
                                                  val,
                                                );

                                                const selectedTax =
                                                  rowTax[rowKey] ?? 0;
                                                calculateRowAmounts(
                                                  rowKey,
                                                  val,
                                                  selectedTax,
                                                  room.TotalRoom,
                                                );
                                              }}
                                              onBlur={() => {
                                                if (editingRowKey === rowKey) {
                                                  handleSaveClick(rowKey, room);
                                                }
                                              }}
                                              className="form-control text-center"
                                              required
                                            />

                                            {/* 🔥 COPY BUTTON ONLY FIRST ROW */}
                                            {isFirstRow &&
                                              (isCopied ? (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm text-danger"
                                                  onClick={handleRemoveCopy}
                                                  title="Remove Copy"
                                                >
                                                  Not Copy
                                                </button>
                                              ) : (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm text-primary"
                                                  onClick={() =>
                                                    handleCopyToAll(
                                                      displayedValue,
                                                    )
                                                  }
                                                  title="Copy to all"
                                                >
                                                  Copy
                                                </button>
                                              ))}
                                          </div>
                                        </td>

                                        <td className="text-center room-col-count">
                                          {room.TotalRoom}
                                        </td>

                                        <td className="room-col-tax-rate">
                                          <select
                                            className="form-select"
                                            disabled={editingRowKey !== rowKey}
                                            value={
                                              rowTax[rowKey] ??
                                              (displayedValue < 7500 ? 5 : 18)
                                            }
                                            onChange={(e) => {
                                              const taxVal = Number(
                                                e.target.value,
                                              );

                                              // 🔥 COPY MODE ON + FIRST ROW → APPLY TO ALL
                                              if (isCopied && rowKey === "0") {
                                                const updatedTax = {};
                                                const updatedTaxAmount = {};
                                                const updatedTotal = {};

                                                roomDetails.forEach(
                                                  (r, idx) => {
                                                    const key = `${idx}`;

                                                    const amt =
                                                      savedAmounts[key] ??
                                                      r.Amount ??
                                                      r.RoomRate ??
                                                      0;

                                                    // ✅ FIX: Rooms count se multiply karke tax base banaya
                                                    const taxableAmt =
                                                      amt * (r.TotalRoom || 1);
                                                    const taxAmt =
                                                      (taxableAmt * taxVal) /
                                                      100;

                                                    updatedTax[key] = taxVal;
                                                    updatedTaxAmount[key] =
                                                      taxAmt;
                                                    updatedTotal[key] =
                                                      taxableAmt + taxAmt;
                                                  },
                                                );

                                                setRowTax(updatedTax);
                                                setRowTaxAmount(
                                                  updatedTaxAmount,
                                                );
                                                setRowTotal(updatedTotal);
                                              } else {
                                                // ✅ NORMAL CASE (copy OFF ya non-first row)
                                                setRowTax((prev) => ({
                                                  ...prev,
                                                  [rowKey]: taxVal,
                                                }));

                                                const amt =
                                                  editingRowKey === rowKey
                                                    ? (tempAmount[rowKey] ??
                                                      defaultAmount)
                                                    : displayedValue;

                                                calculateRowAmounts(
                                                  rowKey,
                                                  amt,
                                                  taxVal,
                                                  room.TotalRoom,
                                                );
                                              }
                                            }}
                                            onBlur={() => {
                                              if (editingRowKey === rowKey) {
                                                handleSaveClick(rowKey, room);
                                              }
                                            }}
                                          >
                                            <option value="">Select</option>
                                            <option value={5}>5%</option>
                                            <option value={18}>18%</option>
                                          </select>
                                        </td>

                                        <td className="text-center room-col-money">
                                          {(rowTaxAmount[rowKey] ?? 0).toFixed(
                                            2,
                                          )}
                                        </td>

                                        <td className="text-center room-col-money">
                                          {(
                                            rowTotal[rowKey] ?? displayedValue
                                          ).toFixed(2)}
                                        </td>

                                        <td className="text-center room-col-action">
                                          {editingRowKey === rowKey ? (
                                            <>
                                              {/* SAVE */}
                                              <button
                                                type="button"
                                                className="btn p-0 text-success me-3"
                                                onClick={() =>
                                                  handleSaveClick(rowKey, room)
                                                }
                                                title="Save"
                                              >
                                                <i
                                                  className="fas fa-check"
                                                  style={{ fontSize: "16px" }}
                                                ></i>
                                              </button>

                                              {/* CANCEL */}
                                              <button
                                                type="button"
                                                className="btn p-0 text-danger"
                                                onClick={handleCancelClick}
                                                title="Cancel"
                                              >
                                                <i
                                                  className="fas fa-times"
                                                  style={{ fontSize: "16px" }}
                                                ></i>
                                              </button>
                                            </>
                                          ) : (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn p-0"
                                                onClick={() =>
                                                  handleEditClick(
                                                    rowKey,
                                                    savedAmounts[rowKey] ??
                                                      defaultAmount,
                                                    room.TotalRoom,
                                                  )
                                                }
                                                title="Edit"
                                              >
                                                <i className="fas fa-edit me-3"></i>
                                              </button>

                                              <button
                                                type="button"
                                                className="btn p-0"
                                                style={{ color: "red" }}
                                                onClick={() =>
                                                  handleDeleteRoom(room.ID)
                                                }
                                                title="Delete"
                                              >
                                                <i className="fas fa-trash"></i>
                                              </button>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className="fw-bold position-absolute rounded-2"
                                style={{
                                  top: "-12px",
                                  paddingInline: "8px",
                                  backgroundColor: "#f5f7fd ",
                                  left: "5px",
                                }}
                              >
                                Total Amount{" "}
                              </h6>
                              <div className="row align-items-end p-3">
                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Amount
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={baseAmount.toFixed(2)}
                                      readOnly
                                    />
                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">+</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <div className="d-flex gap-2 mb-1">
                                      <label className="col-form-label">
                                        Tax
                                      </label>
                                    </div>

                                    <input
                                      type="number"
                                      className="form-control"
                                      value={finalTaxAmount.toFixed(2)}
                                      readOnly
                                    />
                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">=</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Total Amount After Tax
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={finalTotalAfterTax.toFixed(2)}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Reservation Processing Fee */}
                          <div className="col-md-3 mt-3">
                            <label className="form-label fw-bold fs-5">
                              Reservation Processing Fee
                            </label>
                            <input
                              type="number"
                              className="form-control "
                              value={formData.BookingProcessingFee}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  BookingProcessingFee: e.target.value,
                                })
                              }
                            />
                          </div>

                          {/* guest details table */}

                          <div className="col-md-12">
                            <h4 className="mt-3">Guest Details:</h4>
                            <div className="table-responsive">
                              <table
                                className="display table table-striped table-bordered table-hover"
                                style={{
                                  width: "100%",
                                  tableLayout: "auto",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th>Title</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Contact No </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <select
                                        className="form-select form-control"
                                        value={formData.Title}
                                        onChange={(e) =>
                                          setFormData({
                                            ...formData,
                                            Title: e.target.value,
                                          })
                                        }
                                      >
                                        <option>Select Prifix</option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Ms.</option>
                                        <option>Dr.</option>
                                      </select>
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter First Name"
                                        value={formData.FirstName}
                                        onChange={(e) =>
                                          setFormData({
                                            ...formData,
                                            FirstName: e.target.value,
                                          })
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Last Name"
                                        value={formData.LastName}
                                        onChange={(e) =>
                                          setFormData({
                                            ...formData,
                                            LastName: e.target.value,
                                          })
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter Contact No"
                                        value={formData.MobileNumber}
                                        onChange={(e) =>
                                          setFormData({
                                            ...formData,
                                            MobileNumber: e.target.value,
                                          })
                                        }
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Email:</label>
                              <TagsInput
                                value={formData.EmailAddress}
                                onChange={(emails) =>
                                  setFormData({
                                    ...formData,
                                    EmailAddress: emails,
                                  })
                                }
                                name="emails"
                                placeHolder="Enter email "
                              />
                              <div className="form-check d-flex">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Do want to receive Booking Voucher on email ?
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="col-form-label">Address</label>
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                                value={formData.Address}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    Address: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="input-block">
                              <label className="col-form-label">City</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter City"
                                value={formData.City}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    City: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">Country</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Country"
                                value={formData.Country}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    Country: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">State</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter State"
                                value={formData.State}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    State: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">
                                Company Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Company Name"
                                value={formData.CompanyName}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    CompanyName: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className=" fw-bold position-absolute bg-gray1 rounded-2"
                                style={{
                                  top: "-12px",
                                  left: "12px",
                                  paddingInline: "4px",
                                }}
                              >
                                Enter GST Details (Optional)
                              </h6>
                              <div className="row p-3">
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registration Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registration Number"
                                      value={formData.RegistrationNumber}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          RegistrationNumber: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registred Company Name"
                                      value={formData.RegistrationCompanyName}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          RegistrationCompanyName:
                                            e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company address
                                    </label>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder="Registered Company Address"
                                      value={
                                        formData.RegistrationCompanyAddress
                                      }
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          RegistrationCompanyAddress:
                                            e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Billing Instructions:
                              </label>
                              <select
                                className="form-select form-control"
                                value={formData.BillingInstruction}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    BillingInstruction: e.target.value,
                                  })
                                }
                              >
                                <option>Select Billing Instruction</option>
                                <option value="Pay at hotel">
                                  Pay at hotel
                                </option>
                                <option value="Prepaid">Prepaid</option>
                                <option value="Send Invoice">
                                  Send Invoice
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="marketSegment"
                              >
                                Market Segment
                              </label>
                              <select
                                className="form-select form-control"
                                value={formData.MarketSegment}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    MarketSegment: e.target.value,
                                  })
                                }
                              >
                                <option value="">Select</option>
                                {marketSegments &&
                                  marketSegments.map((item) => (
                                    <option key={item.ID} value={item.Code}>
                                      {item.MarketSeg}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label d-flex justify-content-between align-items-center">
                                Business Source
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#SearchAgentModal"
                                >
                                  Change Source
                                </button>
                              </label>
                              <select
                                className="form-select form-control"
                                value={formData.BusinessSource}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    BusinessSource: e.target.value,
                                  })
                                }
                              >
                                <option value="">Select</option>

                                {businessSources.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.BusinessSource}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Guarantee Codes
                              </label>
                              <select
                                className="form-select form-control"
                                value={formData.GuaranteeCodes}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    GuaranteeCodes: e.target.value,
                                  })
                                }
                              >
                                <option value="">Select</option>
                                {guaranteeCodes.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.guaranteeCodes}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Booking Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Special Requriment"
                                value={formData.BookingComment}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    BookingComment: e.target.value,
                                  })
                                }
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Payment Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Payment Comment"
                                value={formData.PaymentComment}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    PaymentComment: e.target.value,
                                  })
                                }
                              ></textarea>
                            </div>
                          </div>

                          {/* <!-- Submit Button --> */}
                          <div className="card-action text-end">
                            <button type="submit" className="btn btn-black">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* pms Sratch */}
        <>
          {/*  Large modal example */}
          <div
            className="modal fade"
            id="SearchAgentModal"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="myLargeModalLabel">
                    Search Opera Source
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-ms-12">
                      <form className="row" onSubmit={handlePMSDetailSearch}>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search here..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="mb-3">
                            <button type="submit" className="btn btn-primary ">
                              Search
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table ">
                          <thead>
                            <tr>
                              <th>Sr #</th>
                              <th>Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {results.length > 0 ? (
                              results.map((item, index) => (
                                <tr key={item.profileIdList?.[0]?.id || index}>
                                  <td>{index + 1}</td>
                                  <td>{item.profile?.formerName?.fullName}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary"
                                      onClick={() =>
                                        handleSelectOperaSource(item)
                                      }
                                    >
                                      Select
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  {loading
                                    ? "Searching..."
                                    : "No results. Please search other agent."}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>

          {/* /.modal */}
        </>
      </div>
    </>
  );
};

export default FinalGroupBooking;
